
import CryptoJS from "crypto-js";

export function hashToken(token: string): string {
  return CryptoJS.SHA256(token).toString(CryptoJS.enc.Hex);
}

